function clamp(value: number, min: number, max: number) {
  if (value < min) return min;
  if (value > max) return max;
  return value;
}

export default clamp;



/** WEBPACK FOOTER **
 ** /Users/songseunggeun/pawsong/gdx-ai.js/src/math/clamp.ts
 **/